import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import moment from 'moment';
import * as _ from 'lodash';
import {
  selectBusinessPartner,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { Block, Title } from '../..';

const Information = () => {
  const translations = useSelector(selectTranslations);
  const { data: businessPartner } = useSelector(selectBusinessPartner);

  // const endContract = useMemo(
  //   () => businessPartner?.extraInfo?.endContract,
  //   [businessPartner?.extraInfo?.endContract],
  // );

  // const startContract = useMemo(
  //   () => businessPartner?.extraInfo?.startContract,
  //   [businessPartner?.extraInfo?.startContract],
  // );

  const getTimeCharge = (startTime: string, endTime: string) => {
    const from = startTime ? moment(startTime).format('DD/MM/YYYY') : '';
    const to = endTime ? moment(endTime).format('DD/MM/YYYY') : '';
    return [from, to].filter(i => i).join(' - ');
  };

  const agentInfoData = useMemo(() => {
    const result = [
      { title: 'b2b.txt.agent-code', value: businessPartner?.extraInfo?.code },
      { title: 'b2b.txt.agent-name', value: businessPartner?.baseInfo?.name },
      {
        title: 'b2b.txt.agent-referrer',
        value: businessPartner?.extraInfo?.remark,
      },
      {
        title: 'b2b.txt.agent-referrer-email',
        value: businessPartner?.extraInfo?.emailAgent,
      },
      {
        title: 'b2c.txt.email-receive-invoices',
        value:
          _.isEmpty(businessPartner?.extraInfo?.email) ||
          !_.isArray(businessPartner?.extraInfo?.email)
            ? ''
            : businessPartner?.extraInfo?.email?.join(',\r\n'),
      },
      {
        title: 'b2b.txt.agent-tax-code',
        value: businessPartner?.extraInfo?.taxNumber,
      },
      {
        title: 'b2b.txt.stateBudgetRelatedUnitCode',
        value: businessPartner?.extraInfo?.stateBudget,
      },
      { title: 'b2b.txt.agent-region', value: businessPartner?.baseInfo?.area },
      {
        title: 'b2b.txt.agent-city',
        value: businessPartner?.baseInfo?.province,
      },
      {
        title: 'b2b.txt.agent-district',
        value: businessPartner?.baseInfo?.district,
      },
      {
        title: 'b2b.txt.agent-address',
        value: businessPartner?.baseInfo?.address,
      },
      // {
      //   title: 'b2b.txt.agent-contract-id',
      //   value: businessPartner?.extraInfo?.contractNumber,
      // },
      // {
      //   title: 'b2b.txt.agent-contract-date',
      //   value: startContract ? moment(startContract).format('DD/MM/YYYY') : '',
      // },
      // {
      //   title: 'b2b.txt.contract-expiration-date',
      //   value: endContract ? moment(endContract).format('DD/MM/YYYY') : '',
      // },
    ];

    const validSeller = businessPartner?.seller?.filter(
      seller => seller.default,
    );

    if (validSeller && validSeller.length) {
      validSeller.forEach(seller => {
        result.push(
          {
            title: 'b2b.txt.personCharge',
            value: seller?.saleCharge,
          },
          {
            title: 'b2b.txt.timeCharge',
            value: getTimeCharge(
              seller.fromCharge ?? '',
              seller.toCharge ?? '',
            ),
          },
        );
      });
    } else {
      result.push(
        {
          title: 'b2b.txt.personCharge',
          value: '',
        },
        {
          title: 'b2b.txt.timeCharge',
          value: '',
        },
      );
    }

    return result;
  }, [
    businessPartner?.baseInfo?.address,
    businessPartner?.baseInfo?.area,
    businessPartner?.baseInfo?.district,
    businessPartner?.baseInfo?.name,
    businessPartner?.baseInfo?.province,
    businessPartner?.extraInfo?.code,
    businessPartner?.extraInfo?.contractNumber,
    businessPartner?.extraInfo?.email,
    businessPartner?.extraInfo?.remark,
    businessPartner?.extraInfo?.taxNumber,
    businessPartner?.seller,
    // endContract,
    // startContract,
    businessPartner?.extraInfo?.emailAgent,
  ]);

  return (
    <Block>
      <Title>{translations?.['b2b.txt.agent-info'] ?? ''}</Title>
      <Content>
        {agentInfoData.map((item, idx, arr) => (
          <StyledRow
            key={idx}
            style={{
              borderTop: idx === 0 ? 'none' : '#EDEDED 1px dashed',
              paddingBottom: idx === arr.length - 1 ? 0 : 8,
              paddingTop: idx === 0 ? 0 : 8,
            }}
          >
            <Col span={12}>
              <InfoTitle>{translations?.[item.title] ?? ''}</InfoTitle>
            </Col>
            <Col span={12}>
              <InfoText>{item.value}</InfoText>
            </Col>
          </StyledRow>
        ))}
      </Content>
    </Block>
  );
};

export default Information;

const StyledRow = styled(Row)``;

const Content = styled.div`
  margin-top: 28px;
`;

const InfoTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`;

const InfoText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
`;
